import type { WebsiteWaitlistStatus } from "@actale/contracts";

export const WEBSITE_WAITLIST_STATUS_LABELS: Record<WebsiteWaitlistStatus, string> = {
  PENDING: "待跟进",
  INVITED: "已邀请",
  TESTING: "已参与",
  CLOSED: "已关闭",
};

export function formatWaitlistDate(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(value));
}
